(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputChosen', cpInputChosen);

    cpInputChosen.$inject = [];

    function cpInputChosen() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-chosen/input-chosen.html',
            scope: {
                title: '@',
                fullWidth: '=?',
                object: '=',
                prop: '@',
                options: '=',
                optionPropTitle: '@',
                optionPropValue: '@',
                isRequired: '=?',
                isDisabled: '=?',
                isMultiple: '=?',
                onChange: '&?'
            },
            link: function(scope, element, attrs, controller) {
            }
        };
    }
})();
